import React from 'react';
export function Footer() {
  return <footer className="bg-brand-bgAlt border-t border-brand-border py-8 px-4 text-center" data-id="element-89">
      <div className="max-w-4xl mx-auto" data-id="element-90">
        <div className="mb-4" data-id="element-91">
          <h3 className="font-heading text-xl font-bold text-brand-title mb-2" data-id="element-92">
            💃 MANUAL DEL INSTRUCTOR DE SEVILLANAS PRO
          </h3>
          <p className="font-body text-brand-subtitle font-semibold mb-2" data-id="element-93">
            El sistema de formación N.1 para instructoras de sevillanas en
            España.
          </p>
          <p className="font-body text-brand-text text-sm italic" data-id="element-94">
            Porque enseñar sevillanas no debería costarte tus noches y tus fines
            de semana.
          </p>
        </div>

        <div className="mb-4" data-id="element-95">
          <p className="font-body text-brand-text text-sm" data-id="element-96">
            📧 digipromarket3@gmail.com
          </p>
        </div>

        <div className="border-t border-brand-border pt-4" data-id="element-97">
          <div className="font-body text-xs text-brand-textMuted tracking-wide mb-2" data-id="element-98">
            © Manual del Instructor de Sevillanas PRO 2025 — Todos los derechos
            reservados.
          </div>
          <div className="font-body text-xs text-brand-textMuted" data-id="element-99">
            Aviso Legal · Política de Privacidad · Política de Cookies
          </div>
        </div>
      </div>
    </footer>;
}